export const environment = {
    baseUrl: "https://pasarelaalarmas.prosegur.com/backend/api/v1/",
    tokenMp: {
        AR: "APP_USR-8fd945db-ea17-48bc-b9c3-f0d783cb7bb1",
        UY: "PENDIENTE",
        PE: "PENDIENTE",
        CO: "PENDIENTE",
        CL: "PENDIENTE",
    }, 
    endpoints: {
        TOKENIZATION: {
            initialInfo: "tokenization/client/initial-info",
            client: "tokenization/client",
            processPayment: "tokenization/process",
        },
        OTP: {
            otp: "otp",
            validation: "otp/validation"
        }
    }
};